import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteLogger = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if debug mode is enabled
    const urlParams = new URLSearchParams(window.location.search);
    const debugParam = urlParams.get('debug');
    const isDebugMode = debugParam === 'true' || localStorage.getItem('debugMode') === 'true';

    if (isDebugMode || process.env.NODE_ENV === 'development') {
      console.log('=== ROUTE CHANGE ===');
      console.log('Pathname:', location.pathname);
      console.log('Search:', location.search);
      console.log('Hash:', location.hash);
      console.log('Full URL:', window.location.href);
      console.log('Timestamp:', new Date().toISOString());
      console.log('===================');
    }

    // Log navigation attempt to console (safe, no sensitive data)
    console.log(`Navigated to: ${location.pathname}`);

  }, [location]);

  return null; // This component doesn't render anything
};

export default RouteLogger;
